import { API_ENDPOINT } from "./api";

export type AuthResponse = {
  token: string;
  userId: string;
  name?: string | null;
};

async function postAuth(
  path: string,
  body: Record<string, unknown>,
  token?: string
): Promise<any> {
  const response = await fetch(`${API_ENDPOINT}${path}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    let errorMessage = `Request failed with ${response.status}`;
    try {
      const errorData = await response.json();
      if (errorData.error) {
        errorMessage = errorData.error;
      }
    } catch {
      // If JSON parsing fails, use the status code message
    }
    throw new Error(errorMessage);
  }

  return response.json();
}

export async function signup(email: string, password: string, name?: string): Promise<AuthResponse> {
  const data = await postAuth("auth/signup", { email, password, name });
  return data as AuthResponse;
}

export async function login(email: string, password: string): Promise<AuthResponse> {
  const data = await postAuth("auth/login", { email, password });
  return data as AuthResponse;
}

export async function getMe(token: string): Promise<{ userId: string; name?: string | null }> {
  const response = await fetch(`${API_ENDPOINT}auth/me`, {
    headers: { Authorization: `Bearer ${token}` },
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch session: ${response.status}`);
  }

  return response.json();
}

